import React, {Component} from 'react';
import {Scrollbars}       from 'react-custom-scrollbars';
import {
  Container,
}                         from 'semantic-ui-react';
import PropTypes          from 'prop-types';
import classnames         from 'classnames';

// Style
import                    './ScrollArea.scss';

const propTypes = {
  addClass : PropTypes.string,
  children : PropTypes.node,
};
const defaultProps = {
  addClass : null,
  children : null,
};

const trackHorizontal = (props) => (
  <div
    {...props}
    style={{display: 'none'}}
  />
);

const renderView = (props) => (
  <div
    {...props}
    className='scroll-content'
  />
);

class ScrollArea extends Component {

  constructor(props) {
    super(props);

    this.state = {
      hideIndicate : false,
      scrolling    : false,
    };

    this.setScrollRef = this.setScrollRef.bind(this);
    this.handleScrollUpdate = this.handleScrollUpdate.bind(this);
    this.scrollRef;
  }

  setScrollRef(ref) {
    this.scrollRef = ref;
  }

  handleScrollUpdate() {
    if (this.scrollRef) {
      const {
        clientHeight,
        scrollHeight,
        scrollTop,
      } = this.scrollRef.getValues();

      const {
        hideIndicate,
        scrolling,
      } = this.state;

      const onBottom = clientHeight + scrollTop >= scrollHeight;

      if (!onBottom && !hideIndicate && clientHeight < scrollHeight && !scrolling) {
        this.setState({scrolling: true});
      }
      else if (!hideIndicate && onBottom && scrolling) {
        this.setState({
          hideIndicate : true,
          scrolling    : false,
        });
      }
      else if (clientHeight >= scrollHeight && (scrolling || hideIndicate)) {
        // Force no scrolling classname if it was set previously
        this.setState({
          hideIndicate : false,
          scrolling    : false,
        });
      }
    }
  }

  render() {
    const {addClass, children} = this.props;

    return (
      <Container className='sgr-mainHome-grid-two-scroll'>
        <Scrollbars
          autoHide
          className={classnames(
            'scroll-gaelle',
            {'scrolling': this.state.scrolling},
            {[addClass]: Boolean(addClass)}
          )}
          hideTracksWhenNotNeeded
          onUpdate={this.handleScrollUpdate}
          ref={this.setScrollRef}
          renderThumbHorizontal={trackHorizontal}
          renderTrackHorizontal={trackHorizontal}
          renderView={renderView}
          style={{height: 300}}
        >
          {children}
        </Scrollbars>
      </Container>
    );
  }

}

ScrollArea.propTypes = propTypes;

ScrollArea.defaultProps = defaultProps;

export default ScrollArea;



// WEBPACK FOOTER //
// ./src/molecules/ScrollArea/ScrollArea.js